import config from "@Config/index";
import axios from "axios";
import { filterActiveChildInventories } from "../RecentelyViewedSection/helper";

export const getInventoryPopularProperties = async (id: any, options: any = {}) => {
  try {
    const res: any = await axios.get(
      `${config.API_URL}/api/v0/inventories/${id}/popular_properties`,
      options,
    );
    let popularPropertiesData = res?.data?.data || [];
    if (popularPropertiesData.length > 0) {
      popularPropertiesData = filterActiveChildInventories(popularPropertiesData);
    }
    return popularPropertiesData;
  } catch (error) {
    if (typeof window !== "undefined" && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`PopularProperties API error for id ${id} -> ${error}`, {
        extra: { id, options, error },
      });
    }
    return { error };
  }
};

export const getInventoryPopularPropertiesById = async (options: any = {}) => {
  const INVENTORY_LIMIT = 10;
  let finalData: any = [];
  const inventoryId = options?.inventory_id;
  const inventoriesOptions = {
    params: {
      limit: INVENTORY_LIMIT,
      only: "id,name,canonical_name,location,available,pricing,region_id,images,status",
      methods:
        "active_children_count,location_coordinates,reviews_count,reviews_rating,meta_short,feature_tags,amber_sales,images_with_featured",
      ...(options?.userCurrency ? { user_currency: options.userCurrency } : {}),
      lang: options?.lang || "en",
    },
  };
  const response: any = await getInventoryPopularProperties(inventoryId, inventoriesOptions);
  if (response?.length > 0) {
    finalData = response;
  }

  return finalData;
};
